import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tuoyuan",
  "use": "icon-tuoyuan-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 13 13\" id=\"icon-tuoyuan\">\n\n<path class=\"st0\" d=\"M6.5,13C2.9,13,0,10.1,0,6.5S2.9,0,6.5,0S13,2.9,13,6.5S10.1,13,6.5,13z M6.5,1C3.5,1,1,3.5,1,6.5\n\tc0,3,2.5,5.5,5.5,5.5c3,0,5.5-2.5,5.5-5.5C12,3.5,9.5,1,6.5,1z\" />\n<path class=\"st0\" d=\"M6.5,11C4,11,2,9,2,6.5S4,2,6.5,2S11,4,11,6.5S9,11,6.5,11z M6.5,3C4.6,3,3,4.6,3,6.5S4.6,10,6.5,10\n\tS10,8.4,10,6.5S8.4,3,6.5,3z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgs/svg/tuoyuan.svg
// module id = EKEJ
// module chunks = 41